import React, { Component } from 'react';
import { Container, Row  } from 'reactstrap';

import './styles.scss';

class ScrollButton extends React.Component {
     constructor() {
          super();
          this.intervalId = 0;
     }

     scrollToTop() {
          this.intervalId = setInterval(()=>{
               if(window.pageYOffset == 0) clearInterval(this.intervalId);
               window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
          },
          this.props.delayInMs
          );
     }

     scrollToBottom() {
          this.intervalId = setInterval(()=>{
               var limit = Math.max( document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight );
               window.scroll(0, limit);
               clearInterval(this.intervalId);
          },
          this.props.delayInMs
          );
     }

     render () {
          return (
               <React.Fragment>
               <button title='Ir al principio' className='scroll scroll-up' onClick={ () => this.scrollToTop()}>
               <span className='cui-arrow-top' aria-hidden='true'></span>
               </button>
               <button title='Ir al final' className='scroll scroll-bottom' onClick={ () => this.scrollToBottom()}>
               <span className='cui-arrow-bottom' aria-hidden='true'></span>
               </button>
               </React.Fragment>
          );
     }
}

export default ScrollButton;



// WEBPACK FOOTER //
// ./src/components/ScrollButton/ScrollButton.js